import { defineComponent } from '@digitalbranch/app'

import template from './projects.page.html'
import css from './projects.page.css'

export const projectsPage = defineComponent({
  name: 'projects-page',
  template,
  css,
})
